import JoalAlertProvider from './alerts-provider.component';

export default JoalAlertProvider;
